import './Loader.scss';

export default function Loader() {
    return (
        <div className={'loader-wrapper'}>
            <div className="bar1" />
            <div className="bar2" />
            <div className="bar3" />
            <div className="bar4" />
            <div className="bar5" />
            <div className="bar6" />
        </div>
    )
}
